import CheckIcon from '../../../../ui/svg/common/check-v';
import React from 'react';
import MilestoneText from './milestone-text';
import { IUpsellRule } from '../../interfaces';

export const CHECKED_CIRCLE_SIZE = 16;
export const UNCHECKED_CIRCLE_SIZE = 13;

interface IMilestoneCircleProps {
    isChecked: boolean;
    pluginsCount: number;
    upsellRule?: IUpsellRule;
    isLast: boolean;
}

const MilestoneCircle = ({ isChecked, pluginsCount, upsellRule, isLast }: IMilestoneCircleProps) => {

    const itemSize = isChecked ? CHECKED_CIRCLE_SIZE : UNCHECKED_CIRCLE_SIZE;

    return (
        <div
            className="flex items-center justify-center relative"
            style={{
                width: `${ itemSize }px`,
                height: `${ itemSize }px`,
                borderRadius: '100%',
                background: isChecked ? '#00BA90' : '#fff',
                border: isChecked ? '2px solid #00BA90' : '2px solid rgb(207, 207, 207)',
            }}
        >
            {
                isChecked &&
                <CheckIcon
                    width={ '10px' }
                    height={ '10px' }
                    color={ '#fff' }
                />
            }

            {
                upsellRule &&
                <MilestoneText
                    isChecked={ isChecked }
                    pluginsCount={ pluginsCount }
                    upsellRule={ upsellRule }
                    isLast={ isLast }
                />
            }
        </div>
    )
};

export default MilestoneCircle;